/**
 * Sjekk om featuretoggle i window.HN er aktiv for et gitt område.
 * @param featureName Navn på featuretoggle
 * @param areaName Area-navn. Hvis areaName ikke er oppgitt, vil det sjekkes om featuretoggle er aktivert globalt.
 */
export const getFeatureToggle = (featureName, areaName) => {
    const getFeatureToggles = window.HN?.PortalCommands?.GetFeatureTogglesV2 || window.HN?.Commands?.GetFeatureTogglesV2;
    return ((getFeatureToggles?.[featureName]?.AreaName === areaName || getFeatureToggles?.[featureName]?.Global === true) &&
        getFeatureToggles?.[featureName]?.Enabled === true);
};
